// use-delete-profile-image.ts — Current-user suite, action.

'use client';

import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/contexts/api';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';
import { currentUserKeys } from './keys';
import type { UserProfile } from './use-current-user';

export function useDeleteProfileImage(): ActionResult<void, UserProfile> {
  const api = useApi();
  const apiProfile = api.profile;
  const queryClient = useQueryClient();

  return useActionHook<void, UserProfile>(
    useMemo(
      () => ({
        mutationFn: async () => {
          await apiProfile.deleteImage();
          return apiProfile.get();
        },
        onInvalidate: (profile) => {
          queryClient.setQueryData(currentUserKeys.profile(), profile);
          queryClient.invalidateQueries({ queryKey: currentUserKeys.profile() });
        },
      }),
      [apiProfile, queryClient],
    ),
  );
}
